import apiCliente from 'utils/apiCliente';
import { esTelefonoValido, normalizarTelefonoInput } from 'utils/userUtils';

const crearError = ({ message, general, validationErrors }) => {
	const error = new Error(message || 'Se produjo un error.');
	if (general) {
		error.general = general;
	}
	if (validationErrors) {
		error.validationErrors = validationErrors;
	}
	return error;
};

export const crearUsuario = async (email, password, nombre, telefono, rol_id) => {
	let errores = {};
	const telefonoNormalizado = normalizarTelefonoInput(telefono).trim();

	if (!nombre || nombre.trim() === '') {
		errores.nombre = 'El nombre no puede estar vacío.';
	}

	if (!telefonoNormalizado || !esTelefonoValido(telefonoNormalizado)) {
		errores.telefono = 'El teléfono debe contener solo números y opcionalmente un + al inicio (8 a 15 dígitos).';
	}

	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	if (!email || !emailRegex.test(email)) {
		errores.email = 'Ingrese un correo electrónico válido.';
	}

	if (!password || password.length < 6) {
		errores.password = 'La contraseña debe tener al menos 6 caracteres.';
	}

	if (Object.keys(errores).length > 0) {
		throw crearError({
			message: 'Verifica los datos ingresados.',
			validationErrors: errores,
		});
	}

	const request = '/usuarios/create';
	const body = {
		email: email,
		password: password,
		nombre: nombre,
		telefono: telefonoNormalizado,
		rol_id: rol_id,
	};

	try {
		const response = await apiCliente.post(request, body);
		return response.data;
	} catch (error) {
		if (error.response) {
			throw crearError({
				message: error.response.data.error || 'Se produjo un error desconocido.',
				general: error.response.data.error || 'Se produjo un error desconocido.',
			});
		} else if (error.request) {
			throw crearError({
				message: 'No se pudo establecer conexión con el servidor.',
				general: 'No se pudo establecer conexión con el servidor.',
			});
		} else {
			throw crearError({
				message: 'Error al realizar la solicitud.',
				general: 'Error al realizar la solicitud.',
			});
		}
	}
};
